import COMMENT from 'constants/comment';

export const addLikeToReview = (modifiedReviewId, review, action) => {
  if (modifiedReviewId !== review.id) {
    return review;
  }

  if (action === COMMENT.ACTIONS.LIKE) {
    return {
      ...review,
      likes: review.likes + 1,
      isLiked: true,
    };
  }

  if (action === COMMENT.ACTIONS.REMOVE) {
    return {
      ...review,
      likes: review.likes - 1,
      isLiked: false,
    };
  }

  return review;
};

export const addDislikeToReview = (modifiedReviewId, review, action) => {
  if (modifiedReviewId !== review.id) {
    return review;
  }

  if (action === COMMENT.ACTIONS.DISLIKE) {
    return {
      ...review,
      likes: review.isLiked ? review.likes - 1 : review.likes,
      isDisliked: true,
    };
  }

  if (action === COMMENT.ACTIONS.REMOVE) {
    return {
      ...review,
      isDisliked: false,
    };
  }

  return review;
};

export const formatCommentAsReview = (comment, parentId) => ({
  id: comment.commentId,
  parentId: parentId,
  text: comment.commentText,
  raw: comment.commentRaw,
  date: comment.commentDate,
  likes: comment.commentLikes,
  statusName: comment.commentStatusName,
  relevance: comment.relevance,
  stars: comment.commentStars,
  user: {
    id: comment.userId,
    level: comment.userLevel,
    name: comment.userName,
    photo: comment.userPhoto,
    specialityName: comment.userSpecialtyName,
    typeName: comment.userTypeName,
    username: comment.userUsername,
  },
  isLiked: comment.isLiked ?? false,
  isDisliked: comment.isDisliked ?? false,
  replies: [],
});

export const formatReviewsAsComments = (reviews, aliasId, isReply) =>
  reviews.map((review) => ({
    commentId: review.id,
    parentId: review.parentId ?? null,
    commentText: review.text,
    commentRaw: review.raw,
    commentDate: review.date,
    commentLikes: review.likes,
    commentStatusName: review.statusName,
    commentFixed: false,
    relevance: review.relevance,
    commentStars: review.stars,
    reviewAliasId: aliasId,
    edited: false,
    isReview: !isReply,
    userId: review.user.id,
    userLevel: review.user.level,
    userName: review.user.name,
    userPhoto: review.user.photo,
    userSpecialtyName: review.user.specialityName,
    userTypeName: review.user.typeName,
    userUsername: review.user.username,
    isLiked: review.isLiked ?? false,
    isDisliked: review.isLiked ?? false,
    replies:
      'replies' in review
        ? formatReviewsAsComments(review.replies, aliasId, true)
        : [],
  }));

export const removeReviewsFromComments = (comments) =>
  comments.filter((comment) => !comment.isReview);
